import { useState, useEffect } from 'react';
import { Stack, IconButton, Typography, Popover, Box } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import CloseIcon from '@mui/icons-material/Close';
import { EventItemDisplay } from './EventItemDisplay';
import { RegistrationTab } from './RegistrationTab';
import { useTBContext } from '../Contexts/useTBStates';
import { StyledIconButton } from '../../shared/Components/StyledIconButton';
import { IOSSwitch } from '../../shared/Components/iosSwitch';
import { TipTapEditor } from '../../shared/Components/TipTapEditor';
import React from 'react';


interface RegistrationDisplayInfoPopoutProps {
    compHeights: any;
    appDims: any;
    saveEvent: () => void;
}

export const RegistrationDisplayInfoPopout = ({compHeights, appDims, saveEvent }: RegistrationDisplayInfoPopoutProps) => {
    
    const { factor, appTheme, viewEvent, setViewEvent } = useTBContext();
    
    const [open, setOpen] = useState(false);
    const [readOnly, setReadOnly] = useState(false);
    const [value, setValue] = useState<string>(viewEvent.registrationInfo || '');
    const [savedValue, setSavedValue] = useState<string>(viewEvent.registrationInfo || '');

    const onChange = React.useCallback((content: string) => {
        setValue(content);
        console.log('Content:',content);
    }, []);

    const handleSave = React.useCallback((htmlContent: string) => {
        console.log('Save:',htmlContent);
        setSavedValue(htmlContent);
        setViewEvent({...viewEvent, registrationInfo: htmlContent});
    }, [viewEvent, setViewEvent]);


    return (
        <Stack direction={'row'} spacing={2} sx={{ display: 'flex', height: 60*factor, justifyContent: 'flex-start', padding: '0px 20px', alignItems: 'center' }}>
            <IconButton color='primary'
                sx = {{
                    width: 'max-content',
                    height: 'max-content',
                    borderRadius: 2,
                    padding: 0.5,
                    justifyContent: 'flex-start',
                    border: '1px solid transparent',
                    '&:hover': {border: `1px solid ${appTheme.palette.primary.extraLight}`},
                    '&:active': {backgroundColor: 'transparent'},
                    '&:focus': {backgroundColor: 'transparent'},
                }}
                onClick={() => {
                    setOpen(true);
                }}>
                <Typography variant='subtitle2' color='primary.main' sx={{ fontWeight: 500, fontSize: 14, display: 'flex', alignItems: 'center', textAlign: 'left', justifyItems: 'center' }}>
                    <LaunchIcon sx={{ fontSize: 16, marginRight: 1 }} />Registration Info
                </Typography>
            </IconButton>
            <Popover
                open={open}
                anchorEl={document.getElementById('tournament-builder-footer')}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}  
                PaperProps={{
                    sx: {
                        backgroundColor: 'white',
                        margin: 'auto 3%', // Center horizontally
                        width: '90vw', // Ensure it has a defined width,
                        height: '90vh',
                        padding: 2,
                    }
                }}
            >
                <Stack spacing={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <Stack direction={'row'} spacing={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant='h5'>Registration Info</Typography>
                        <Stack direction={'row'} spacing={2} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography>Read Only</Typography>
                            <IOSSwitch checked={readOnly} onChange={(e) => setReadOnly(e.target.checked)} />
                            <StyledIconButton
                                factor={factor}
                                color='primary'
                                icon={<></>}
                                width={'max-content'}
                                height={'max-content'}
                                label={'Save'}
                                onClick={() => {
                                    handleSave(value);
                                }}
                                appTheme={appTheme}
                            />
                            <IconButton color='error'
                                onClick={() => {
                                    setOpen(false);
                                    saveEvent();
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                    </Stack>
                    {readOnly ? 
                        (<Box flex={1} maxHeight={`calc(100% - 100px)` }>
                            <TipTapEditor 
                                value={value} 
                                onChange={onChange} 
                                readOnly={true} 
                            />
                        </Box>)
                        :
                        (
                        <TipTapEditor 
                            value={value} 
                            onChange={onChange} 
                            readOnly={false} 
                        />
                    )
                    }
                </Stack>
            </Popover>
        </Stack>
    )
}
